import classNames from 'classnames';
import { useLenis } from 'lenis/react'
import { useEffect, useRef, useState } from 'react';
import { useMeasure, useWindowSize } from 'react-use';

import { Arrow } from '@/components/arrow';
import { useTouchScreen } from '@/helpers/hooks';
import { useStore } from '@/helpers/store';
import { clamp, mapRange } from '@/helpers/utils';

type StaticProps = {
  onScroll?: (scroll: number, progress: number) => void;
  children?: React.ReactNode;
  title?: string;
  backgroundColor?: string;
  textColor?: string;
  id?: string;
};

export const Static = (props: StaticProps) => {
  const { onScroll, children, title, backgroundColor = 'bg-at', textColor = 'text-white', id } = props;

  const [sectionWrapperRef] = useMeasure();
  const mySectionWrapperRef = useRef<HTMLElement | null>(null);

  return (
    <section
      ref={(node) => {
        node && sectionWrapperRef(node);
        mySectionWrapperRef.current = node;
      }}
      id={id}
      className={classNames('w-full')}
    >
      <div className={classNames(backgroundColor, textColor, 'h-full')}>
        <div
          className={classNames(
            'px-container flex h-full flex-col justify-end transition-opacity duration-200 ease-linear desktop:justify-center',
          )}
        >
          <div className="relative">
            {title && (
              <h1
                className={classNames(
                  'kerning-[-2%px] font-soehne text-[42px] font-halbfett leading-[1.09] tablet:text-[60px] tablet:leading-[1.2] desktopXL:text-[70px]',
                )}
              >
                {title}
              </h1>
            )}
            {children && <>{children}</>}
          </div>
        </div>
      </div>
    </section>
  );
};
